
export enum RestauranteAnalyticsTipoAcesso {
    VISUALIZOU_PERFIL = "visualizou_perfil",
    CLICOU_WHATSAPP = "clicou_whatsapp",
    CLICOU_CARDAPIO = "clicou_cardapio",
    CLICOU_ROTA = "clicou_rota",
}

export const RotuloTipoAcesso: Record<RestauranteAnalyticsTipoAcesso, string> = {
    [RestauranteAnalyticsTipoAcesso.VISUALIZOU_PERFIL]: "Visualizou o perfil",
    [RestauranteAnalyticsTipoAcesso.CLICOU_WHATSAPP]: "Clicou no WhatsApp",
    [RestauranteAnalyticsTipoAcesso.CLICOU_CARDAPIO]: "Clicou no cardápio",
    [RestauranteAnalyticsTipoAcesso.CLICOU_ROTA]: "Clicou na rota",
}

export const IconeTipoAcesso: Record<RestauranteAnalyticsTipoAcesso, string> = {
    [RestauranteAnalyticsTipoAcesso.VISUALIZOU_PERFIL]: "pi pi-eye",
    [RestauranteAnalyticsTipoAcesso.CLICOU_WHATSAPP]: "pi pi-whatsapp",
    [RestauranteAnalyticsTipoAcesso.CLICOU_CARDAPIO]: "pi pi-book",
    [RestauranteAnalyticsTipoAcesso.CLICOU_ROTA]: "pi pi-map-marker",
}
